import { config } from '../config'
import { Title, MainImage, WrapperImage } from '../styles'

import { Case } from './Case'
import { Wrapper, RightHexagon } from './styles'

const {
  development: { title, stages, image, rightHexagon },
} = config

export function Development() {
  return (
    <Wrapper>
      <RightHexagon {...rightHexagon} />
      <Title as="h2">{title}</Title>
      {stages.map(stage => (
        <Case key={stage.id} {...stage} />
      ))}
      <WrapperImage>
        <MainImage {...image} />
      </WrapperImage>
    </Wrapper>
  )
}
